/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CommonLimitDictionaryItem} from '../models/CommonLimitDictionaryItem';
import type {Error} from '../models/Error';

export interface GetCommonLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCommonLimitsRequest = createAction<PayloadData<void>>('GET_COMMON_LIMITS__GET_COMMON_LIMITS__REQUEST');
export const getCommonLimitsSuccess = createAction<PayloadData<Array<CommonLimitDictionaryItem>>>('GET_COMMON_LIMITS__GET_COMMON_LIMITS__SUCCESS');
export const getCommonLimitsFailure = createAction<PayloadData<Error, void, true>>('GET_COMMON_LIMITS__GET_COMMON_LIMITS__FAILURE');

export const getCommonLimitsActions = [
    getCommonLimitsRequest,
    getCommonLimitsSuccess,
    getCommonLimitsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCommonLimits = (config?: GetCommonLimits$Config) => {
    return {
        CALL_API: {
            types: getCommonLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/common-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

